export const NNBSP = '\u202f';